import { getApi, postApi } from "../apiCall";

export const getTenderList = ({ section, tenderType }) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/list?page=0&size=100&section=${section}&tenderType=${tenderType}`;
  return getApi(url);
};

export const getTendersBiddersList = ({ section, tenderType }) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/getTendersForBidders?page=0&size=100&section=${section}&tenderType=${tenderType}`;
  return getApi(url);
};

export const getRaTendersBiddersList = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/listRATendersForBidders`;
  return getApi(url);
};

export const getequisitionsList = (id, bidStage) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/${id}/getRequisitions?bidStage=${bidStage}`;
  return getApi(url);
};

export const getequisitionsBidders = (id, bidStage) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/${id}/getRequisitionsForBidders?bidStage=${bidStage}`;
  return getApi(url);
};

export const getTenderSpeceficDetail = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/details/${id}`;
  return getApi(url);
};

export const getRaArchive = ({ role, status, tenderType }) => {
  let finalStatus = status?.toLocaleUpperCase();
  if (finalStatus === "WITHDRAWN") {
    finalStatus = "TERMINATED";
  }
  if (finalStatus === "CLOSED") {
    finalStatus = "TERMS";
  }

  const params = [];
  const statusValue = role === "generator" ? "CLOSED" : finalStatus;
  if (statusValue) params.push(`status=${statusValue}`);
  if (tenderType) params.push(`tenderType=${tenderType}`);

  const query = params.length ? `?${params.join("&")}` : "";
  const url = `${process.env.REACT_APP_API_URL}/bsra/tender/archive/${role}${query}`;

  return getApi(url);
};

export const getBidHistory = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/bid/list`;
  return postApi(url, payload);
};

export const getAllGenerators = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/generatorDetails/all-simple`;
  return getApi(url);
};

export const getDocument = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/doc/generate/listing/PDF/BSRA/${id}`;
  return postApi(url, {}, {}, false, "blob");
};

export const getOthersGenerators = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/generatorDetails/excluding-state/${id}`;
  return getApi(url);
};

export const getSelfGenerators = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/generatorDetails/by-state-id/${id}`;
  return getApi(url);
};
